import {LitElement, html} from 'lit';
import {BaseComponent} from '../basecomponent.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TransformChainTestDialog} from './transformChainTestDialog.js';
import {attachTransformChainLabel} from '../../utils/transformChainUtil.js';

/**
 * Transform chain option field with tester tool. Wrap in a div when placed in vaadin-form-layout.
 */
/* global customElements */
class TransformChainField extends BaseComponent {

	static get properties() {
		return {
			style: {type: String},
			textstyle: {type: String},
			label: {type: String},
			classes: {type: String},
			required: {type: Boolean},
			name: {type: String},
			helperText: {type: String}
		};
	}

	constructor() {
		super();

		var field = this;
		field.style = '';
		field.textstyle = '';
		field.label = 'Transform chain';
		field.name = 'transformChain';
		field.classes = '';
		field.required = false;
		field.helperText = '';

		setTimeout(function () {
			field.init();
		});
	}

	render() {
		return html`
			<style>
				.icon-btn {
					border: 1px solid lightgray;
					padding: 5px;
					height: 36px;
					box-sizing: border-box;
					display: inline-flex;
					align-items: center;
					justify-content: center;
					margin-bottom: 4px;
					border-radius: 7px 7px 7px 7px;
				}
				.icon-btn:hover {
					background: lightgray;
					cursor: pointer;
				}
				.chain-field-wrap {
					display: flex;
					align-items: flex-end;
					gap: 4px;
				}
			</style>
			<span style="${this.style}" class="${this.classes} chain-field-wrap">
				<slot name="text"></slot>
				<span style="width: 40px; height: 40px; flex-shrink: 0;">
					<vaadin-icon itemid="tester-icon" icon="vaadin:tools" class="icon-btn" title="Open transform chain tester"></vaadin-icon>
				</span>
			</span>
		`;
	}

	init() {
		var field = this;

		ElementUtil.query(field, 'tester-icon').addEventListener('click', function () {
			TransformChainTestDialog.show({
				chainValue: field.getValue(),
				onApply: function (chainValue) {
					field.setValue(chainValue);
				}
			});
		});

		var label = field.getAttribute('label') || field.label;
		var fieldName = field.getAttribute('name') || field.name;
		var helperText = field.getAttribute('helper-text') || field.helperText;

		var textField = ElementUtil.create({
			tag: 'vaadin-text-field',
			itemid: 'text',
			slot: 'text',
			name: fieldName,
			style: field.textstyle + '; flex: 1; min-width: 0;',
			autocomplete: 'off',
			preventInvalidInput: false
		});

		attachTransformChainLabel(textField, label);

		if (helperText) {
			textField.setAttribute('helper-text', helperText);
		}
		if (field.required || field.hasAttribute('required')) {
			textField.required = true;
		}
		if (field.getAttribute('value')) {
			textField.value = field.getAttribute('value');
		}
		if (field._pendingValue != null) {
			textField.value = field._pendingValue;
			field._pendingValue = null;
		}

		field.append(textField);
	}

	getValue() {
		var field = this;
		var textField = ElementUtil.query(field, 'text');
		if (textField) {
			return textField.value;
		}
		return field._pendingValue || '';
	}

	setValue(newValue) {
		var field = this;
		var textField = ElementUtil.query(field, 'text');
		if (textField) {
			textField.value = newValue != null ? newValue : '';
			field._pendingValue = null;
		} else {
			field._pendingValue = newValue;
		}
	}

	getCustomValue() {
		return this.getValue();
	}

	setCustomValue(newValue) {
		this.setValue(newValue);
	}

	markError(message) {
		var textField = ElementUtil.query(this, 'text');
		if (textField) {
			textField.errorMessage = message;
			textField.invalid = true;
		}
	}
}

customElements.define('dl-transform-chain-field', TransformChainField);
